var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownGrade = function SvgDownGrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10a.833.833 0 0 0-1.667 0v1.917l-1.477-1.742L12.3 7.751a.833.833 0 0 0-1.058-.175L7.684 9.75 3.976 5.3a.834.834 0 0 0-1.283 1.067l4.166 5a.833.833 0 0 0 1.067.182l3.566-2.141 3.333 3.925H12.5a.833.833 0 1 0 0 1.666h4.167a.917.917 0 0 0 .3-.058l.116-.067a.992.992 0 0 0 .125-.075.625.625 0 0 0 .117-.142.917.917 0 0 0 .075-.116.533.533 0 0 0 .042-.142.65.65 0 0 0 .058-.233V10Z",
    fill: "#F99137",
    fillRule: "nonzero"
  })));
};
export default SvgDownGrade;